import PrimeVue from "primevue/config"
import Aura from "@primeuix/themes/aura"
import ToastService from "primevue/toastservice"
import DialogService from "primevue/dialogservice"
import DrawerService from "@/services/DrawerService"
import Tooltip from "primevue/tooltip"
import { definePreset } from "@primeuix/themes"

const customPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: "#E1F5FF",
      100: "#B3E0F7",
      200: "#80C9F0",
      300: "#4DB8E8",
      400: "#26A1D1",
      500: "#2699D5",
      600: "#1F8FC4",
      700: "#177BB3",
      800: "#116C99",
      900: "#0E5C7F",
      950: "#0A4C66"
    }
  }
})

export default {
  install(app) {
    app.use(PrimeVue, {
      theme: {
        preset: customPreset,
        options: {
          darkModeSelector: ".app-dark"
        }
      }
    })
    app.use(ToastService)
    app.use(DialogService)
    app.use(DrawerService)

    app.directive("tooltip", Tooltip)
  }
}
